import { createAction } from 'typesafe-actions';

export const toggleIsSeparatedInputTypeAction = createAction('filters/isSeparatedInputTypeChanged')();
